/* eslint-disable no-param-reassign */
function dataTableFOUSearchDefinitions(el) {
	el.defMaterials = [
		{
			className: "",
			targets: [0],
		},
		{
			className: "o-search-result-materials__title",
			targets: [1],
		},
		{
			className: "o-search-result-materials__date",
			targets: [2],
		},
		{ className: "o-search-result-materials__manchet", targets: [3] },
	];
	el.columnsMaterials = [
		{
			targets: 0,
			data: (row) => {
				const hasImgUrl = row.imageUrl && row.imageUrl.length > 0;

				const extraImgClass = !hasImgUrl
					? " o-search-result-materials__image--no-image"
					: "";
				const filmClass =
					row.hasVideo === true
						? " o-search-result-materials__image--has-video"
						: "";
				const imgTag = hasImgUrl ? `<img loading="lazy" src="${row.imageUrl}" alt="" />` : "";
				return `<div class="o-search-result-materials__image${filmClass}${extraImgClass}">
							${imgTag}
						</div>`;
			},
		},
		{
			targets: 1,
			data: (row) =>
				`<a href="${row.url}" title="${row.type}: ${row.title}"><h3>${row.title}</h3></a>`,
		},
		{
			targets: 2,
			data: (row) =>
				`<time datetime="${row.date}" class="o-search-result-materials__date">${row.date}</time>`,
		},
		{
			targets: 3,
			data: (row) => `<p>${row.manchet}</p>`,
		},
	];
}

export default dataTableFOUSearchDefinitions;
